// SlideStage — picks a custom animated React slide component when one exists
// for this slide_index, otherwise renders the static PNG.  Receives
// `progress` (0..1) from the narration audio so animations stay synced,
// plus quiz-state hints so "test then reveal" slides know whether to show
// the answer (e.g. slide 4 hides the four-forces arrows until the user has
// correctly recalled them).
//
// slideQuizFlags: array of booleans, one per quiz on this slide, in slide
// order.  Each entry is true if the user has answered that quiz correctly at
// some point this session.  Lets custom slides remember reveals when the
// lesson advances to the next narration on the same slide.
import Slide03RevisionWorkCycle from "./slides/Slide03RevisionWorkCycle";
import Slide04ActingForces from "./slides/Slide04ActingForces";
import Slide05ForcesInTurn from "./slides/Slide05ForcesInTurn";
import Slide06AdverseYaw from "./slides/Slide06AdverseYaw";

// Registry keyed by the lesson slide_index (1-based).
// Add more entries as we animate more slides.
const REGISTRY = {
  3: Slide03RevisionWorkCycle,
  4: Slide04ActingForces,
  5: Slide05ForcesInTurn,
  6: Slide06AdverseYaw,
};

export default function SlideStage({
  slideIndex,
  progress,
  quizCorrect = false,
  isQuizBlock = false,
  slideQuizFlags = [],
  fallbackImage,
}) {
  const Custom = REGISTRY[slideIndex];
  if (Custom) {
    return (
      <div className="w-full h-full bg-[#1b3151]" data-testid={`slide-anim-${slideIndex}`}>
        <Custom
          progress={progress ?? 0}
          quizCorrect={quizCorrect}
          isQuizBlock={isQuizBlock}
          slideQuizFlags={slideQuizFlags}
        />
      </div>
    );
  }
  return (
    <img
      src={fallbackImage}
      alt=""
      className="w-full h-full object-contain bg-white"
      data-testid="slide-image"
    />
  );
}
